export default __webpack_public_path__ + "static/media/2024.7fbc7a52.png";